import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface FullscreenLoaderProps {
  message?: string;
  progress?: number; // 0-100, undefined = indeterminate
}

export function FullscreenLoader({ message = "Opération en cours…", progress }: FullscreenLoaderProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 max-w-sm w-full px-6">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-lg font-medium text-foreground text-center">{message}</p>
        {progress !== undefined && (
          <Progress value={progress} className="w-full h-2" />
        )}
      </div>
    </div>
  );
}
